import { ErrorMessage, Field } from 'formik';

interface InputFieldProps {
    label?: string;
    name: string;
    type?: string;
    disabled?: boolean;
    maxLength?: number;
    value?: string;
    onClick?:()=>void;
    
}
const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
        event.preventDefault();
    }
};
export const InputField = ({ name, type, label, disabled, maxLength,value,onClick=()=>{}  }: InputFieldProps): any => {
    return (
        <div>
            {label && <label className="label">{label}</label>}
            <Field as="input" onKeyDown={handleKeyDown}   disabled={disabled} maxLength={maxLength>0? maxLength:100} type={type ? type : 'input'} className="form-control  mb-3" name={name}  
            // onChange={onChange} 
            //  value={value} 
            onClick ={onClick} 
             />
            <small className="errorMsg">
                <ErrorMessage name={name} />
            </small>
        </div>
    );
};

